import React from 'react';


const SocialMediaButton = ({ shareUrl, title }) => {
  // It's crucial to URL-encode the link and title to ensure they are passed correctly
  const encodedShareUrl = encodeURIComponent(shareUrl);
  const encodedTitle = encodeURIComponent(title);

  return (
    <div style={{ paddingTop: '20px', paddingBottom: '20px' }}>
      {/* Facebook Share Link */}
      <a 
        href={`https://www.facebook.com/sharer/sharer.php?u=${encodedShareUrl}`}
        target="_blank" 
        rel="noopener noreferrer"
      >
        <img src="/assets/img/facebook.png" alt="Share on Facebook" style={{ height: '40px', width: '40px', marginRight: '15px' }} />
      </a>

      {/* Telegram Share Link */}
      <a 
        href={`https://t.me/share/url?url=${encodedShareUrl}&text=${encodedTitle}`}
        target="_blank" 
        rel="noopener noreferrer"
      >
        <img src="/assets/img/telegram.png" alt="Share on Telegram" style={{ height: '40px', width: '40px', marginRight: '15px' }} />
      </a>

      {/* Twitter Share Link */}
      <a 
        href={`https://twitter.com/intent/tweet?url=${encodedShareUrl}&text=${encodedTitle}`}
        target="_blank" 
        rel="noopener noreferrer"
      >
        <img src="/assets/img/twitter.png" alt="Share on Twitter" style={{ height: '40px', width: '40px', marginRight: '15px' }} />
      </a>

      {/* WhatsApp Share Link */}
      <a 
        href={`https://api.whatsapp.com/send?text=${encodedTitle}%20${encodedShareUrl}`}
        target="_blank" 
        rel="noopener noreferrer"
      >
        <img src="/assets/img/whatsapp.png" alt="Share on WhatsApp" style={{ height: '40px', width: '40px', marginRight: '15px' }} />
      </a>
    </div>
  );
};

export default SocialMediaButton;